import { IUser } from '@/framework/user/types';
import type { PendingPopup } from '@/framework/user/pendingPopupsState';

/** Laravel UserResource / JSON user payload → Recoil IUser */
export const mapToIUser = (raw: unknown): IUser => {
  const u = raw as Record<string, unknown>;
  const inner = (u?.data as Record<string, unknown>) ?? u;

  return {
    username: (inner.username ?? inner.name) as string | undefined,
    country: inner.country as string | undefined,
    id: inner.id as number | undefined,
    losses: inner.losses as string | undefined,
    rank: inner.rank as number | undefined,
    score: inner.score as number | undefined,
    wins: inner.wins as string | undefined,
    total: inner.total as string | undefined,
    activeGem: inner.active_gem as IUser['activeGem'],
    sparks: Number(inner.sparks ?? 0),
    xp: Number(inner.xp ?? 0),
    level: Number(inner.level ?? 1),
    xpIntoLevel: Number(inner.xp_into_level ?? 0),
    xpForNext: Number(inner.xp_for_next ?? 100),
    emailVerified: Boolean(inner.email_verified),
    isGuest: Boolean(inner.is_guest),
    hasEmail: Boolean(inner.has_email),
  };
};

export const mapPendingPopups = (raw: unknown): PendingPopup[] => {
  const u = raw as Record<string, unknown>;
  const inner = (u?.data as Record<string, unknown>) ?? u;
  const popups = inner.pending_popups;

  if (!Array.isArray(popups)) {
    return [];
  }

  return popups.map((popup) => {
    const p = popup as Record<string, unknown>;
    return {
      type: p.type as PendingPopup['type'],
      slug: String(p.slug),
      title: p.title as string | undefined,
      description: p.description as string | undefined,
      payout: p.payout as PendingPopup['payout'] | undefined,
    };
  });
};
